import React from 'react';
import './OtherServicesSection.css';

const OtherServicesSection: React.FC = () => {
  const services = [
    { name: "Quick wash (Exterior Only)", price: "$59" },
    { name: "Headlights Restoration", price: "$99" },
    { name: "Cut and Polish with Gold package", price: "$249" },
    { name: "Clay Bar treatment", price: "$49" },
    { name: "Ceramic coating", price: "$699" },
    { name: "Heavy Pet Hair removing", price: "$49" },
  ];

  return (
    <div className="other-services-section">
      <h2>Our Other Services</h2>
      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-name">{service.name}</div>
            <div className="service-price">{service.price}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OtherServicesSection;
